import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import * as XLSX from 'xlsx';


function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

const DealerInvoiceReport = () => {
    const location = useLocation();
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    const dealerId = getQueryParam('id') || ""; 
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);  
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());  
    const [getData, setGetData] = useState([]);
    console.log(getData);

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    
    const months = [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 },
    ];

    const years = Array.from({ length: currentYear - 2023 }, (_, i) => {
        const year = 2024+ i;
        return { label: year.toString(), value: year };
    });

    useEffect(() => {
        const getdata = async () => {
            try {
                const response = await axios.post('https://api.trucoo.in/invoice/monthly/', {month: selectedMonth, year: selectedYear},{
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });

                console.log("Response:", response.data);

                if (response.data.status === 'success') {
                    setGetData(response.data.data || []);
                }else{
                    setGetData([]);
                    console.error("Error:", response.data.message);
                }
            } catch (error) {
                console.error("Error:", error.response || error.message);
            }
        };
        getdata();
    }, [selectedMonth, selectedYear]);

    const filteredData = getData.filter(order => {
        const orderDate = new Date(order.date);
        const isDealerMatch = dealerId === "" || String(order.dealerId) === dealerId;
        return isDealerMatch && orderDate.getFullYear() === currentYear && orderDate.getMonth() + 1 === selectedMonth;
    });

    let grandTotalIncentive = 0;
    let grandTotalpayment = 0;
    let grandTotalTransport = 0;
    let grandTotalMargin = 0;

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, `Incentive_${filteredData[0]?.dealerData?.dealer}_${selectedMonth}.xlsx`);
    };

    //console.log(selectedMonth, selectedYear);

    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Incentive Reports</h4>
                                <p className="mb-0 box-subtitle">Monthly Dealer Incentive</p>
                            </div>
                            
                            <div className="box-body">
                                <div class="row"> 
                                    <div class="col-lg-3 mb-4">
                                        <select value={selectedMonth} onChange={(e) => setSelectedMonth(Number(e.target.value))} className="form-select">
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>{month.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div class="col-lg-3 mb-4">
                                        <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))} className="form-select">
                                            {years.map((month) => (
                                                <option key={month.value} value={month.value}>{month.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div class="col-lg-3 mb-4" align="right"></div>
                                    <div class="col-lg-3 mb-4" align="right">
                                        <button onClick={downloadExcel} className="btn btn-sm btn-primary"> <i class="fa fa-download"></i> Excel </button>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="table-responsive">
                                        {filteredData?.length > 0 ?
					                        <table id="printableArea" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Invoice ID</th>
                                                        <th>Date</th>
                                                        <th>Dealer </th>
                                                        <th>Distributer</th>
                                                        <th>Total Liters</th>
                                                        <th>Payment</th>
                                                        <th>Transport</th>
                                                        <th>Margin</th>
                                                        <th>Incentive</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredData.map((order, index) => {
                                                        
                                                        const totalLiters = Array.isArray(order.orderData) ? order.orderData.reduce((sum, item) => {
                                                            return sum + (Number(item.itemWeight) / 1000) * Number(item.qty);  
                                                        }, 0) : 0;
                                                        
                                                        
                                                        const totalIncentive = totalLiters * Number(order.dealerData.incentive || 0);
                                                        const totalTransport = totalLiters * Number(order.dealerData.transPort|| 0);
                                                        const totalMargin = totalLiters * Number(order.dealerData. margin|| 0);
                                                        
                                                        
                                                        grandTotalIncentive += totalIncentive;
                                                        grandTotalTransport += totalTransport;
                                                        grandTotalMargin += totalMargin;
                                                        grandTotalpayment += Number(parseFloat(order.totalPayment) - parseFloat(order.discount));

                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>#{formatNumber(order.id, 6)}</td>
                                                                <td>{order.date}</td>
                                                                <td>{order.dealerData.dealer}</td>
                                                                <td>{order.dealerData.name}</td>       
                                                                <td>{totalLiters.toFixed(2)}</td>
                                                                <td>{Number(parseFloat(order.totalPayment) - parseFloat(order.discount)).toFixed(2)}</td>
                                                                <td>{totalTransport.toFixed(2)}</td>
                                                                <td>{totalMargin.toFixed(2)}</td>
                                                                <td>{totalIncentive.toFixed(2)}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                    <td colSpan="4" className="text-right font-weight-bold"></td>
                                                        <th colSpan="2" className="text-right font-weight-bold">Grand Total</th>
                                                        <th colSpan="1" className="font-weight-bold">{grandTotalpayment.toFixed(2)}</th>
                                                        <th colSpan="1" className="font-weight-bold">{grandTotalTransport.toFixed(2)}</th>
                                                        <th colSpan="1" className="font-weight-bold">{grandTotalMargin.toFixed(2)}</th>
                                                        <th colSpan="1" className="font-weight-bold">{grandTotalIncentive.toFixed(2)}</th>
                                                        
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            :
                                            <p class="text-danger" align="center"> No Data Available</p>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default DealerInvoiceReport;
